function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { htmlToElement } from '@grrr/utils';
import EventDispatcher from './event-dispatcher';
/**
 * Dialog tab list with cookie tabs.
 */

var DialogTabList = function DialogTabList(_ref) {
  var config = _ref.config,
      preferences = _ref.preferences;
  var events = EventDispatcher();
  var TYPE = config.get('type');
  var PREFIX = config.get('prefix');
  /**
   * Render cookie tabs.
   */

  var renderTab = function renderTab(_ref2, index) {
    var id = _ref2.id,
        label = _ref2.label,
        description = _ref2.description,
        required = _ref2.required,
        checked = _ref2.checked,
        accepted = _ref2.accepted;

    /**
     * Check if the checkbox should be checked:
     *
     * 1. If any preference is saved, use that.
     * 2. If it's explicitly `required` in the settings, mark it checked (ignore
     *    `required: false`, because of #3)
     * 3. Use the `checked` setting.
     */
    var shouldBeChecked = typeof accepted !== 'undefined' ? accepted : required === true ? required : checked;
    return "\n      <li role=\"presentation\">\n        <header class=\"".concat(PREFIX, "__tab\">\n          <label class=\"").concat(PREFIX, "__option\" data-required=\"").concat(required, "\">\n            <input type=\"").concat(TYPE === 'radio' ? 'radio' : 'checkbox', "\" name=\"").concat(PREFIX, "-input\" value=\"").concat(id, "\" ").concat(shouldBeChecked ? 'checked' : '', " ").concat(required && TYPE !== 'radio' ? 'disabled' : '', ">\n            <span>").concat(label, "</span>\n          </label>\n          <a\n            class=\"").concat(PREFIX, "__tab-toggle\"\n            role=\"tab\"\n            id=\"").concat(PREFIX, "-tab-").concat(index, "\"\n            href=\"#").concat(PREFIX, "-tabpanel-").concat(index, "\"\n            aria-controls=\"").concat(PREFIX, "-tabpanel-").concat(index, "\"\n            aria-selected=\"false\"\n            aria-label=\"").concat(config.get('labels.aria.tabToggle'), "\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 16\"><path d=\"M21.5.5l3 3.057-12 11.943L.5 3.557 3.5.5l9 9z\"/></svg>\n          </a>\n        </header>\n        <div\n          class=\"").concat(PREFIX, "__tab-panel\"\n          role=\"tabpanel\"\n          id=\"").concat(PREFIX, "-tabpanel-").concat(index, "\"\n          aria-labelledby=\"").concat(PREFIX, "-tab-").concat(index, "\"\n          aria-hidden=\"true\">\n          <div class=\"").concat(PREFIX, "__tab-description\">\n            ").concat(description, "\n          </div>\n        </div>\n      </li>\n    ");
  };
  /**
   * Render cookie tab list.
   */


  var renderTabList = function renderTabList() {
    var cookies = config.get('cookies', true) || [];
    var cookiesWithState = cookies.map(function (cookieType) {
      return _objectSpread(_objectSpread({}, cookieType), {}, {
        accepted: preferences.get(cookieType.id) ? preferences.get(cookieType.id).accepted : undefined
      });
    });
    return "\n      <ul class=\"".concat(PREFIX, "__tab-list\" role=\"tablist\" aria-label=\"").concat(config.get('labels.aria.tabList'), "\">\n        ").concat(cookiesWithState.map(renderTab).join(''), "\n      </ul>\n    ");
  };
  /**
   * Tab list element.
   */


  var tabList = htmlToElement(renderTabList());
  /**
   * Simple method to get values from cookie checkboxes.
   */

  var getValues = function getValues() {
    var inputs = _toConsumableArray(tabList.querySelectorAll('input'));

    return inputs.map(function (input) {
      return {
        id: input.value,
        accepted: input.checked
      };
    });
  };
  /**
   * Handle tab selection.
   */


  var selectTab = function selectTab(_ref3) {
    var tabs = _ref3.tabs,
        panels = _ref3.panels,
        targetTab = _ref3.targetTab;
    var controls = targetTab ? targetTab.getAttribute('aria-controls') : '';
    tabs.forEach(function (tab) {
      return tab.setAttribute('aria-selected', tab === targetTab);
    });
    panels.forEach(function (panel) {
      return panel.setAttribute('aria-hidden', controls !== panel.id);
    });
  };
  /**
   * Attach event listener for tab click event.
   */


  var attachTabClickListeners = function attachTabClickListeners() {
    var tabs = _toConsumableArray(tabList.querySelectorAll('[role="tab"]'));

    var panels = _toConsumableArray(tabList.querySelectorAll('[role="tabpanel"]'));

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var targetTab = tab.getAttribute('aria-selected') === 'true' ? null : tab;
        selectTab({
          tabs: tabs,
          panels: panels,
          targetTab: targetTab
        });
      });
    });
  };

  return {
    init: function init() {
      attachTabClickListeners();
    },
    on: events.add,
    element: tabList,
    getValues: getValues
  };
};

export default DialogTabList;